import { offer } from '../data/offer';

export const META_PIXEL_ID = '1590544002540527';

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

/** Loads the Meta Pixel base code once and fires PageView. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return;

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) fbq.callMethod(...args);
    else fbq.queue.push(args);
  } as Fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  fbq('init', META_PIXEL_ID);
  fbq('track', 'PageView');
}

export function trackMetaEvent(event: string, params?: Record<string, unknown>): void {
  window.fbq?.('track', event, params);
}

/** Fires InitiateCheckout whenever a link to the checkout is clicked. */
export function trackCheckoutClicks(): () => void {
  const checkout = offer.checkoutUrl;
  if (!checkout) return () => undefined;

  const onClick = (e: MouseEvent) => {
    const link = (e.target as HTMLElement | null)?.closest('a');
    if (link && link.href.startsWith(checkout)) {
      trackMetaEvent('InitiateCheckout', {
        content_name: 'HYROX Mega Pack',
        value: offer.price ?? undefined,
        currency: offer.currency ?? undefined,
      });
    }
  };
  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
}
